import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface UserProfile {
    accessToken: string;
    accountType: number;
    userRole: string;
    address: string;
    backgroundImage: string;
    companyAddress: string;
    companyFacebook: string;
    companyInstagram: string;
    companyLinkedin: string;
    companyMobile: string;
    companyName: string;
    companyWebSite: string;
    companyYoutube: string;
    email: string;
    firstName: string;
    gender: number;
    id: number;
    lastName: string;
    logonMethod: string;
    phoneNumber: string;
    photoUrl: string;
    refreshToken: string;
    telegramNumber: string;
    userId: string;
    userName: string;
    whatsappNumber: string;
    others?: string;
    companyINN?: string;
    isUserAgreement?: 0 | 1;
}

const emptyUser: UserProfile = {
    accessToken: '',
    accountType: 1,
    userRole: '',
    address: '',
    backgroundImage: '',
    companyAddress: '',
    companyFacebook: '',
    companyInstagram: '',
    companyLinkedin: '',
    companyMobile: '',
    companyName: '',
    companyWebSite: '',
    companyYoutube: '',
    email: '',
    firstName: '',
    gender: 1,
    id: 0,
    lastName: '',
    logonMethod: '',
    phoneNumber: '',
    photoUrl: '',
    refreshToken: '',
    telegramNumber: '',
    userId: '0',
    userName: '',
    whatsappNumber: ''
};

const initialState = {
    user: emptyUser,
    isLoggedIn: false,
    isTokenExpired: false,
    isLoading: false
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
            state.isLoggedIn = true;
        },
        clearUser: (state) => {
            state.user = emptyUser;
            state.isLoggedIn = false;
        },
        setTokenExpired: (state, action: PayloadAction<boolean>) => {
            state.isTokenExpired = action.payload;
        },
        clearAccessToken: (state) => {
            state.user.accessToken = '';
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setAccessToken: (state, action: PayloadAction<string>) => {
            state.user.accessToken = action.payload;
        },
        setRefreshToken: (state, action: PayloadAction<string>) => {
            state.user.refreshToken = action.payload;
        },
        setAccountType: (state, action: PayloadAction<number>) => {
            state.user.accountType = action.payload;
        }
    },
    extraReducers: {}
});

export const { setUser, clearUser, setTokenExpired, clearAccessToken, setLoading, setAccessToken, setRefreshToken, setAccountType } = userSlice.actions;

export default userSlice.reducer;

export {
    selectUser,
    selectUserId,
    selectUserName,
    selectUserRole,
    selectIsLoggedIn,
    selectIsTokenExpired,
    selectUserLoading,
    selectAccessToken
} from '../selectors';
